// Independent of A-F CCMR — do not import Ccmr/* or write ccmrIndicators*.
import { connect } from 'react-redux';
import Component from './OutcomesBonus.component';
import { getSchools } from '../Settings/+store/SchoolSettings';
import { getOutcomesBonus, uploadOutcomesBonusFile } from './+store';

// The grad year we initially fetch: prefer the year on the most-recently-loaded node's
// aggregate, otherwise the current calendar year (the callable defaults to the newest
// child key when the requested year is missing, so this is just the first-paint hint).
const deriveGradYear = (outcomesBonus) => {
  const aggregate = outcomesBonus && outcomesBonus.aggregate;
  if (aggregate && aggregate.gradYear) return String(aggregate.gradYear);
  return String(new Date().getFullYear());
};

const mapStateToProps = (state) => {
  const { profile } = state.modules.Auth.auth;
  const outcomesBonus = state.modules.OutcomesBonus.outcomesBonus.outcomesBonus || {};
  return {
    profile,
    outcomesBonus,
    gradYear: deriveGradYear(outcomesBonus),
    schoolList: state.modules.Settings.schoolSettings.schoolList,
    loading: !!state.modules.OutcomesBonus.outcomesBonus.loadingMsg,
    loadingMsg: state.modules.OutcomesBonus.outcomesBonus.loadingMsg,
    upload: state.modules.OutcomesBonus.outcomesBonus.upload,
  };
};

const mapDispatchToProps = (dispatch) => ({
  init: (profile) => {
    dispatch(getSchools(profile));
  },
  getOutcomesBonus: (gradYear) => {
    dispatch(getOutcomesBonus(gradYear));
  },
  uploadFile: (profile, file, gradYear) => {
    dispatch(uploadOutcomesBonusFile(profile, file, gradYear));
  },
});

const Container = connect(mapStateToProps, mapDispatchToProps)(Component);

export default Container;
